import { render, staticRenderFns } from "./WebResources.vue?vue&type=template&id=3105845c"
import script from "./WebResources.vue?vue&type=script&lang=js"
export * from "./WebResources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports